import { supabase } from '@/lib/supabase';

export interface CostKPIs {
  total_cost_eur: number;
  cogs_cost_eur: number;
  marketing_cost_eur: number;
  revenue_eur: number;
  margin_eur: number;
  margin_pct: number;
}

export interface FunctionBreakdown {
  function_name: string;
  cost_eur: number;
  call_count: number;
  category: 'cogs' | 'marketing';
}

export interface DailyPoint {
  date: string;
  cogs_eur: number;
  marketing_eur: number;
  revenue_eur: number;
}

export interface TopUser {
  user_id: string;
  email: string;
  total_cost_eur: number;
  credits_purchased_eur: number;
  net_margin_eur: number;
  call_count: number;
}

export interface CostStatsResponse {
  range: { from: string; to: string };
  kpis: CostKPIs;
  breakdown_by_function: FunctionBreakdown[];
  daily_series: DailyPoint[];
  top_users: TopUser[];
}

export async function fetchCostStats(from: Date, to: Date): Promise<CostStatsResponse> {
  const { data, error } = await supabase.functions.invoke('admin-cost-stats', {
    body: { from: from.toISOString(), to: to.toISOString() },
  });
  if (error) throw new Error(`[adminCostService] ${error.message}`);
  if (!data?.success) throw new Error(`[adminCostService] ${data?.error ?? 'unknown error'}`);
  return data as CostStatsResponse;
}
